WithSalesTax = require 'views/billing/with-sales-tax'
formatMoney = require 'lib/format/money'
l = require 'lib/localize-count'
t = require('views/internal/recup-with-helpers')('manage_members')

module.exports = t.statelessRenderable 'Summary', ({ addSelectedMembers, price, salesTaxForSubscriberUrl, selectedMembersCount, subscriptionIntervalKey }) ->
  addToTeamButtonClass = if selectedMembersCount then '' else '.disabled'
  licenseCountText = l 'new member license count', selectedMembersCount

  t.div ->
    t.div '.summary-header.quiet', -> t.format 'summary'
    t.div '.summary', ->
      t.div '.license-count', -> t.text licenseCountText
      t.div '.quiet', -> t.format subscriptionIntervalKey
      t.div '.total', -> t.createElement WithSalesTax,
        salesTaxForSubscriberUrl: salesTaxForSubscriberUrl
        subtotals: [price]
        renderLoading: -> t.span '.spinner'
        renderError: -> t.span()
        renderContents: ([tax]) ->
          t.format 'total-price', price: formatMoney price + tax
    t.button ".primary.full#{addToTeamButtonClass}",
      { onClick: addSelectedMembers, disabled: !selectedMembersCount },
      -> t.format 'add-to-team'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/summary.coffee